var _rect, _g, _rect2, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideocam = function SvgVideocam(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4872_42951",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4872_42951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.04297 19.9961C3.49297 19.9961 3.02214 19.8003 2.63047 19.4086C2.2388 19.0169 2.04297 18.5461 2.04297 17.9961V5.99609C2.04297 5.44609 2.2388 4.97526 2.63047 4.58359C3.02214 4.19193 3.49297 3.99609 4.04297 3.99609H16.043C16.593 3.99609 17.0638 4.19193 17.4555 4.58359C17.8471 4.97526 18.043 5.44609 18.043 5.99609V10.4961L21.193 7.34609C21.3596 7.17943 21.543 7.13776 21.743 7.22109C21.943 7.30443 22.043 7.46276 22.043 7.69609V16.2961C22.043 16.5294 21.943 16.6878 21.743 16.7711C21.543 16.8544 21.3596 16.8128 21.193 16.6461L18.043 13.4961V17.9961C18.043 18.5461 17.8471 19.0169 17.4555 19.4086C17.0638 19.8003 16.593 19.9961 16.043 19.9961H4.04297Z",
    fill: "#263DBA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4872_42951",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 13,
    height: 12
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.99414,
    y: 6,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4872_42951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25859 16.1664C9.18359 16.1414 9.12109 16.0977 9.07109 16.0352C9.02109 15.9727 8.99609 15.8956 8.99609 15.8039V13.0039H8.49609C8.22109 13.0039 7.98568 12.906 7.78984 12.7102C7.59401 12.5143 7.49609 12.2789 7.49609 12.0039V8.00391C7.49609 7.72891 7.59401 7.49349 7.78984 7.29766C7.98568 7.10182 8.22109 7.00391 8.49609 7.00391H11.4211C11.6878 7.00391 11.9023 7.10807 12.0648 7.31641C12.2273 7.52474 12.2753 7.75391 12.2086 8.00391L11.4961 10.5039H12.0586C12.3586 10.5039 12.5815 10.6372 12.7273 10.9039C12.8732 11.1706 12.8586 11.4289 12.6836 11.6789L9.68359 16.0164C9.63359 16.0914 9.56901 16.1414 9.48984 16.1664C9.41068 16.1914 9.33359 16.1914 9.25859 16.1664Z",
    fill: "white"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideocam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/videocam.3fc7914d.svg";
export { ForwardRef as ReactComponent };